"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatten = void 0;
function isBuffer(obj) {
    var _a, _b;
    return (obj &&
        (obj === null || obj === void 0 ? void 0 : obj.constructor) &&
        typeof ((_a = obj === null || obj === void 0 ? void 0 : obj.constructor) === null || _a === void 0 ? void 0 : _a.isBuffer) === 'function' &&
        ((_b = obj === null || obj === void 0 ? void 0 : obj.constructor) === null || _b === void 0 ? void 0 : _b.isBuffer(obj)));
}
function keyIdentity(key) {
    return key;
}
function flatten(target, opts) {
    var _a, _b;
    const delimiter = (_a = opts === null || opts === void 0 ? void 0 : opts.delimiter) !== null && _a !== void 0 ? _a : '.';
    const maxDepth = opts === null || opts === void 0 ? void 0 : opts.maxDepth;
    const transformKey = (_b = opts === null || opts === void 0 ? void 0 : opts.transformKey) !== null && _b !== void 0 ? _b : keyIdentity;
    const output = {};
    function step(object, prev, currentDepth) {
        currentDepth = currentDepth || 1;
        Object.keys(object).forEach(function (key) {
            var _a;
            const value = object[(_a = opts === null || opts === void 0 ? void 0 : opts.valueKey) !== null && _a !== void 0 ? _a : key];
            const isarray = (opts === null || opts === void 0 ? void 0 : opts.safe) && Array.isArray(value);
            const type = Object.prototype.toString.call(value);
            const isbuffer = isBuffer(value);
            const isobject = type === '[object Object]' || type === '[object Array]';
            const newKey = prev
                ? prev + delimiter + transformKey(key)
                : transformKey(key);
            if (!isarray &&
                !isbuffer &&
                isobject &&
                Object.keys(value).length &&
                (!(opts === null || opts === void 0 ? void 0 : opts.maxDepth) || currentDepth < maxDepth)) {
                return step(value, newKey, currentDepth + 1);
            }
            output[newKey] = value;
        });
    }
    step(target);
    return output;
}
exports.flatten = flatten;
//# sourceMappingURL=notification-template-utils.js.map